<template>
  <div class="learning-path-progress-bar">
    <div class="label">{{ label }}</div>
    <div class="track row no-gutters">
      <div class="bar" :class="`col-${width}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    learningPath: { type: Object, required: true },
  },
  computed: {
    label() {
      return `${this.learningPath.completed_courses} of ${this.learningPath.total_courses} course(s) completed`;
    },
    width() {
      var completed = this.learningPath.completed_courses || 0;
      var total = this.learningPath.total_courses || 0;
      return Math.round((completed / total) * 12);
    },
  },
};
</script>